import { sha256 } from './hashing';

// Generate SHA256 token from order reference and email — (order_reference|email)
// This matches Shopify's sha256 Liquid filter
export async function generateToken(orderReference: string, email: string): Promise<string> {
  const emailLower = email.toLowerCase();
  const tokenData = `${orderReference}|${emailLower}`;

  return sha256(tokenData);
}
